/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TextQuoteAIcon16Light } from './TextQuoteAIcon16Light';
import { TextQuoteAIcon16Regular } from './TextQuoteAIcon16Regular';
import { TextQuoteAIcon16Solid } from './TextQuoteAIcon16Solid';
import { TextQuoteAIcon20Light } from './TextQuoteAIcon20Light';
import { TextQuoteAIcon20Regular } from './TextQuoteAIcon20Regular';
import { TextQuoteAIcon20Solid } from './TextQuoteAIcon20Solid';
import { TextQuoteAIcon24Regular } from './TextQuoteAIcon24Regular';
import { TextQuoteAIcon24Solid } from './TextQuoteAIcon24Solid';
import { TextQuoteAIcon32Regular } from './TextQuoteAIcon32Regular';
import { TextQuoteAIcon64Regular } from './TextQuoteAIcon64Regular';
var sizes = {
    16: {
        light: TextQuoteAIcon16Light,
        regular: TextQuoteAIcon16Regular,
        solid: TextQuoteAIcon16Solid,
    },
    20: {
        light: TextQuoteAIcon20Light,
        regular: TextQuoteAIcon20Regular,
        solid: TextQuoteAIcon20Solid,
    },
    24: {
        regular: TextQuoteAIcon24Regular,
        solid: TextQuoteAIcon24Solid,
    },
    32: {
        regular: TextQuoteAIcon32Regular,
    },
    64: {
        regular: TextQuoteAIcon64Regular,
    },
};
export var TextQuoteAIcon = forwardRef('TextQuoteAIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
